<template>
  <router-view />
</template>
<script setup>

// 只在生产环境下开启
if (process.env.NODE_ENV === "production") {
  // 1.禁用右键菜单
  document.oncontextmenu = new Function("event.returnValue=false");
  // 2.禁止键盘F12键
  document.addEventListener("keydown", function (e) {
    if (e.key == "F12") {
      e.preventDefault();
    }
  });

  // 3.禁止进入调试模式
  // setInterval(function () {
  //   check();
  // }, 1000);
  // var check = function () {
  //   function doCheck(a) {
  //     if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
  //       (function () {})["constructor"]("debugger")();
  //     } else {
  //       (function () {})["constructor"]("debugger")();
  //     }
  //     doCheck(++a);
  //   }
  //   try {
  //     doCheck(0);
  //   } catch (err) {}
  // };
}

</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
